<template>
  <div
    id="custom-button"
    :class="[model, { 'position-center': model == 'is_card' }]"
  >
    <a
      class="custom-main"
      @click="click_button"
      :href="
        custom_button.button_url ? custom_button.button_url : 'javascript:;'
      "
      :target="custom_button.button_url?'_blank':''"
    >
      <div v-if="img_path == 'amazon-1'" class="amazon-1">
        <img :src="require('@/images/a.png').default" alt="" style="right: 10px" />
      </div>
      <div v-else-if="img_path == 'amazon-2'" class="amazon-2">
        <img :src="require('@/images/aa.png').default" alt="" style="left: 0" />
        <img :src="require('@/images/a.png').default" alt="" style="left: 10px" />
      </div>
      <div v-else-if="img_path == 'amazon-3'" class="amazon-3">
        <img :src="require('@/images/a.png').default" alt="" style="left: 10px" />
        <img :src="require('@/images/Amazon.png').default" alt="" style="right: 10px" />
      </div>
      <div v-else-if="img_path == 'ebay-1'" class="ebay-1">
        <img :src="require('@/images/eBay.png').default" alt="" style="right: 10px" />
      </div>
      <div v-else-if="img_path == 'ebay-2'" class="ebay-2">
        <img
          :src="require('@/images/ebaybackground.png').default"
          alt=""
          style="left: 0"
        />
        <img :src="require('@/images/eBayebay.png').default" alt="" style="left: 10px" />
      </div>
      <div v-else-if="img_path == 'ebay-3'" class="ebay-3">
        <img :src="require('@/images/eebay.png').default" alt="" style="left: 10px" />
        <img :src="require('@/images/eeeBay.png').default" alt="" style="right: 10px" />
      </div>
      <div v-else-if="img_path == 'aliexpress-1'" class="aliexpress-1">
        <img
          :src="require('@/images/aliexpress1.png').default"
          alt=""
          style="left: 50%; top: 0; transform: translateX(-50%)"
        />
        <img :src="require('@/images/c.png').default" alt="" style="right: 10px" />
      </div>
      <div v-else-if="img_path == 'aliexpress-2'" class="aliexpress-2">
        <img
          :src="require('@/images/aliexpress.png').default"
          alt=""
          style="top: 60%; left: 10px"
        />
      </div>
      <div v-else-if="img_path == 'aliexpress-3'" class="aliexpress-3">
        <img :src="require('@/images/ali.png').default" alt="" style="left: 10px" />
        <img
          :src="require('@/images/aliexpress2.png').default"
          alt=""
          style="right: 10px"
        />
      </div>
      <!-- 自定义按钮 -->
      <div
        v-else
        :style="{
          borderRadius: '5px',
          backgroundColor: custom_button.background_color,
          color: custom_button.text_color,
        }"
      ></div>
      <span
        class="button-text"
        :style="{ color: img_path ? '' : custom_button.text_color }"
      >
        {{ custom_button.button_text }}
      </span>
    </a>
  </div>
</template>
<script>
// import API from "../../../API";
export default {
  props: {
    custom_button: {
      require: true,
    },
    model: {
      default: "product_button",
    },
  },
  data() {
    return {
      img_path: null,
      img_prefix: null,
      img_suffix: null,
      button_type: null
    };
  },
  methods: {
    adjust_width(current_width) {
      let css_payload = {};
      if (250 < current_width && current_width < 400) {
        css_payload = {
          width: current_width+"px",
          transform: "translate(-50%, -50%)scale(0.7)",
        };
      } else if (0 < current_width && current_width < 250) {
        css_payload = {
          width: 1.5*current_width+"px",
          transform: "translate(-50%, -50%)scale(0.5)",
        };
      }
      this.$(this.$el).css(css_payload);
    },
    compute_width() {
      let parent = this.$(this.$el).parent();
      let brother_img = parent.children("img");
      this.adjust_width(parent.width());
      if (brother_img && brother_img.length) {
        brother_img[0].onload = () => {
          this.adjust_width(this.$(this.$el).parent().children("img").width());
        };
      }
    },
    click_button() {
      try {
        let payload = {
          product_id: this.custom_button.product_id,
        };
        this.$axios.post(API.click_button, payload);
      } catch (error) {
        console.log(error);
      }
    },
  },
  beforeMount() {
    let { button_type, button_style } = this.custom_button;
    switch (button_type.toLocaleLowerCase()) {
      case "amazon":
        this.img_prefix = "amazon";
        break;
      case "ebay":
        this.img_prefix = "ebay";
        break;
      case "aliexpress":
        this.img_prefix = "aliexpress";
      case "custom":
        this.button_type = "custom";
        break;
      default:
        this.img_prefix = null;
        break;
    }
    switch (button_style.toLocaleLowerCase()) {
      case "first":
        this.img_suffix = "1";
        break;
      case "second":
        this.img_suffix = "2";
        break;
      case "third":
        this.img_suffix = "3";
        break;
      default:
        this.img_suffix = null;
        break;
    }
    this.img_path =
      this.img_prefix && this.img_suffix
        ? this.img_prefix + "-" + this.img_suffix
        : null;
  },
  mounted() {
    this.$nextTick(() => {
      if (this.model == "is_card") {
        this.$(window).resize( ()=> {
          this.compute_width();
        });
        this.compute_width();
      }
    });
  },
};
</script>
<style scoped lang='scss'>
#custom-button {
  display: inline-block;
  width: 100%;
  height: 54px;
  .custom-main {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
    // & > img {
    //   width: 100%;
    //   max-height: 54px;
    // }
    & > div {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
      img {
        width: auto;
        position: absolute;
        left: unset;
        height: auto;
        max-height: 90%;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .button-text {
      font-weight: 700;
      z-index: 2;
      display: inline-block;
      position: absolute;
      top: 50%;
      left: 50%;
      white-space: nowrap;
      transform: translate(-50%, -50%);
      color: rgb(255, 255, 255);
      font-size: 18px;
    }
    .amazon-1 {
      border-radius: 27px;
      background-color: #535a62;
      &::after {
        content: "";
        display: inline-block;
        width: calc(100% - 6px);
        height: calc(100% - 6px);
        position: absolute;
        border-radius: 28px;
        top: 3px;
        left: 3px;
        pointer-events: none;
        border: 2px solid rgba(255, 255, 255, 0.5);
      }
      & + span {
        color: #fff;
      }
    }
    .amazon-2 {
      border-radius: 5px;
      background-color: #ffb045;
      & + span {
        color: #fff;
      }
    }
    .amazon-3 {
      border: 1px solid #b28513;
      background-color: #efc352;
      & + span {
        color: #222;
      }
    }
    .ebay-1 {
      border: 2px solid #146ade;
      border-radius: 27px;
      background-color: #edf3fd;
      & + span {
        color: #0852d1;
      }
    }
    .ebay-2 {
      border-radius: 5px;
      background-color: #f8e376;
      & + span {
        color: #222;
      }
    }
    .ebay-3 {
      background-color: #044165;
      & + span {
        color: #fac636;
      }
    }
    .aliexpress-1 {
      background-color: #e53c30;
      border-radius: 27px;
      border: 4px solid #ff7471;
      & + span {
        color: #fff;
      }
    }
    .aliexpress-2 {
      border-radius: 5px;
      background-color: #ff4747;
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        display: inline-block;
        background-color: white;
        height: 1px;
        bottom: 11px;
        left: 101px;
        opacity: 0.3;
      }
      & + span {
        color: #fff;
      }
    }
    .aliexpress-3 {
      background-color: #ff7701;
      & + span {
        color: #fff;
      }
    }
  }
}
#custom-button.product_button {
  width: 100%;
  margin-top: 15px;
}
#custom-button.is_card {
  width: 50%;
  height: 42px;
  // .custom-main {
  //   & > div {
  //     img {
  //       max-width: 12%;
  //     }
  //   }
  // }
}
// @media screen and( max-width: 768px) {
//   #custom-button.is_card {
//     width: 90%;
//     .custom-main {
//       & > div {
//         img {
//           max-width: 9%;
//         }
//       }
//       .button-text {
//         font-size: 14px;
//       }
//     }
//   }
// }
// @media screen and( max-width: 575px) {
//   #custom-button.is_card {
//     width: 90%;
//     height: 34px;
//     .custom-main {
//       .button-text {
//         font-size: 12px;
//       }
//       & > div {
//         img {
//           max-width: 14%;
//         }
//       }
//     }
//   }
// }
</style>